var map = {
	"./add-existing-registry-banner.gif": 1856,
	"./addexistingregistry_379x180_v2.jpg": 811,
	"./addexistingregistry_548x260.jpg": 1857,
	"./computer.png": 617,
	"./computer@2x.png": 1858,
	"./event.png": 299,
	"./event@2x.png": 1859,
	"./faq.png": 1860,
	"./faq@2x.png": 1861,
	"./home.png": 1862,
	"./home@2x.png": 1863,
	"./photo.png": 1864,
	"./photo@2x.png": 1865,
	"./poi.png": 1866,
	"./poi@2x.png": 1867,
	"./registry-video.jpg": 1868,
	"./registry-video@2x.jpg": 1869,
	"./registry.png": 1870,
	"./registry@2x.png": 1871,
	"./registryconversion_zolaintegration.jpg": 1872,
	"./registryconversion_zolaintegration@2x.jpg": 1873,
	"./rsvp.png": 1874,
	"./rsvp@2x.png": 1875,
	"./travel.png": 1876,
	"./travel@2x.png": 1877,
	"./wedding_party.png": 1878,
	"./wedding_party@2x.png": 1879
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1855;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages nonrecursive \.(jpg|jpeg|png|gif|svg)(\?.*)?$
// module id = 1855
// module chunks = 50